// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#legal figure{border-radius:.35rem;width:fit-content}#legal figure img{border-radius:.35rem}\n", ""]);
// Exports
module.exports = exports;
